/// <summary>
/// dashboard visual for a simple signal 
/// Author: AFU<br />
/// Date: 13.8.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 -  13.8.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.DashboardSimpleSignal", jQuery.common.vcBaseV4, {


    _create: function () {
        this._createVisual(417);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            // Locate the root container element by its CSS class.
            me._setRoot(".vc-dashboard-item-data");
            me.myRoot.css("height", "100%");
           
            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            // Fetch signals first, then initialize the dashboard with the loaded data.
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
  

    _buildHtml: function () {
        var me = this;
        try {
            // Master reference object holding all DOM element references for easy access.
            me.myHtml = {};
            me.myHtml.wrapper = me._setObj("", "dashboard-simplesignal-wrapper");
            me.myHtml.pic = me._setObj("", "dashboard-simplesignal-icon-area color-fill-secondary");
            me.myHtml.info = me._setObj("", "dashboard-simplesignal-info");
            me.myHtml.name = me._setObj("", "dashboard-simplesignal-name").css("line-height", "1.4");
            me.myHtml.valueRow = me._setObj("", "dashboard-simplesignal-value-row");
            me.myHtml.value = me._setObj("", "dashboard-simplesignal-value");
            me.myHtml.unit = me._setObj("", "dashboard-simplesignal-unit");

            me.myHtml.wrapper.append(me.myHtml.pic, me.myHtml.info);
            me.myHtml.info.append(me.myHtml.name, me.myHtml.valueRow);
            me.myHtml.valueRow.append(me.myHtml.value, me.myHtml.unit);

            me.myRoot.html(me.myHtml.wrapper);


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _formatNumber: function (raw) {
            if(raw === null || raw === undefined) return "--";
            if (!raw && raw !== 0) return "--";
            var parts = raw.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.length > 1 ? parts[0] + "," + parts[1] : parts[0];
        } ,
   

    _fetch: function () {
        var me = this;
        try {

            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1, SumValues: true, ShowSignalGroupIcon: true }, function (result) {
                if (result === null) { me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false); return false; }
                if (result.Entries === null) { me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false); return false; }
                if (result.Entries.length == 0) { me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false); return false; }
                var val = parseFloat(result.Entries[0].Value);
                me.myHtml.value.html(result.Entries[0].Status != -1 ? me._formatNumber(!isNaN(val) ? val.toFixed(2) : result[0].Value) : "--");
                me.myHtml.name.html(result.Entries[0].Name);
                me.myHtml.unit.html(result.Entries[0].Unit);
                me.myHtml.pic.html(result.Entries[0].SignalGroupIcon || "");
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) { me.myHtml.wrapper.hide();}

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});